<h3>{{ formSchema?.title }}</h3>

<mat-card>
  @if (setupForm) {
    <mat-card-content>
      <form [formGroup]="setupForm">
        <div [class]="bannerClass">
          <mat-icon>{{ bannerIcon }}</mat-icon>
          {{ bannerText }}
        </div>
        <formly-form [fields]="section" [model]="setupForm?.getRawValue()" [form]="setupForm"></formly-form>
      </form>
    </mat-card-content>
  }
</mat-card>
